// extracted by mini-css-extract-plugin
export default {"buttons":"QuickFilter_buttons__cYVTY","delete":"QuickFilter_delete__tQLQx"};